import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import {
  TextInput,
  DateInput,
  CustomSwitch,
  IntInput,
} from "components/Input/Index.js";
import AutocompleteInputMeters from "components/Input/AutocompleteInputMeters.js";
import CustomSelect from "components/Input/CustomSelect.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { memberorder } from "variables/markets";
import {
  memberorderTypeData,
  memberorderElectricitySegment,
  memberorderElectricityTurpeVersionC5,
  memberorderElectricityTurpeVersionC4C3C2,
  memberorderElectricityTurpeVersionC5Ecl,
  memberorderElectricityEclHourCount,
  memberorderElectricityRenewableMix,
  memberorderGasProfil,
  memberorderGasTariff
} from "variables/lists/markets";
import { putMarketMembershipOrder, getMarketMeters } from "services/ConfigServices";
import { MarketsContext } from "context/MarketsContext";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import LocalizationAutocomplete from "components/LocalizationAutocomplete/LocalizationAutocomplete";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "98%",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "98%",
  },
}));

const Subsectiontitle = styled.div`
font-size: 14px;
font-weight: 600;
opacity: 1;
font-family: "Source Sans Pro", sans-serif;
margin-top: 15px;
`;

function EditServiceOrderDialog(props) {
  const { closeModal, refetch, serviceorder } = props;
  const appContext = useContext(MarketsContext);
  const { market } = appContext;
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = advancedSearchContext;

  const [ordertype, setOrdertype] = useState(serviceorder.parameters.ordertype);
  const [marketmembershipname, setMarketmembershipname] = useState(serviceorder.parameters.marketmembershipname);
  const [marketmembershipaddress, setMarketmembershipaddress] = useState(serviceorder.parameters.marketmembershipaddress);
  const [marketmembershipnumber, setMarketmembershipnumber] = useState(serviceorder.parameters.marketmembershipnumber);
  const [marketmembershipsiret, setMarketmembershipsiret] = useState(serviceorder.parameters.marketmembershipsiret);
  const [numeroaffaire, setNumeroaffaire] = useState(serviceorder.parameters.numeroaffaire);
  const [referentname, setReferentname] = useState(serviceorder.parameters.referentname);
  const [referentemail, setReferentemail] = useState(serviceorder.parameters.referentemail);
  const [referentphone, setReferentphone] = useState(serviceorder.parameters.referentphone);
  const [creationdate, setCreationdate] = useState(serviceorder.parameters.creationdate)

  const [membershipMeters, setMembershipMeters] = useState([]);
  const [meter, setMeter] = useState({});
  const [pdl, setPdl] = useState(serviceorder.parameters.pdl);
  const [pdlusagecode, setPdlusagecode] = useState(serviceorder.parameters.pdlusagecode);
  const [pdladdress, setPdladdress] = useState(serviceorder.parameters.pdladdress);
  const [pdlinseecode, setPdlinseecode] = useState(serviceorder.parameters.pdlinseecode);
  const [pdlreferenceconsumption, setPdlreferenceconsumption] = useState(serviceorder.parameters.pdlreferenceconsumption);
  const [pdldropmeter, setPdldropmeter] = useState(serviceorder.parameters.pdldropmeter);
  const [pdlname, setPdlname] = useState(serviceorder.parameters.pdlname);
  const [pdloldname, setPdloldname] = useState(serviceorder.parameters.pdloldname);
  const [pdloldaddress, setPdloldaddress] = useState(serviceorder.parameters.pdloldaddress);
  const [pdloldusagecode, setPdloldusagecode] = useState(serviceorder.parameters.pdloldusagecode);
  const [pdlcontractualdata, setPdlcontractualdata] = useState(serviceorder.parameters.pdlcontractualdata);
  const [pdloldcontractualdata, setPdloldcontractualdata] = useState(serviceorder.parameters.pdloldcontractualdata);

  const [comments, setComments] = useState(serviceorder.parameters.comments);
  const [startdate, setStartdate] = useState(serviceorder.parameters.startdate);
  const [enddate, setEnddate] = useState(serviceorder.parameters.enddate);
  const [renewablemix, setRenewablemix] = useState(serviceorder.parameters.renewablemix);
  const [billregroupname, setBillregroupname] = useState(serviceorder.parameters.billregroupname);
  const [billregroupcode, setBillregroupcode] = useState(serviceorder.parameters.billregroupcode);
  const [billbudgetcode, setBillbudgetcode] = useState(serviceorder.parameters.billbudgetcode);

  const [localizationValue, setLocalizationValue] = useState("");
  const [options, setOptions] = useState([]);
  const [validatedAddress, setValidatedAddress] = useState({});
  const [pdlvalidatedAddress, setPdlvalidatedAddress] = useState({});
  const [pdloldvalidatedAddress, setPdloldvalidatedAddress] = useState({});
  const loaded = useRef(false);

  const [groups, setGroups] = useState("");
  const [groupsParent, setGroupsParent] = useState(
    market?.parameters?.general?.groups?.[0]
  );

  const status = serviceorder.parameters.status;

  const [buttonDisabled, setButtonDisabled] = useState(false);

  const handleSubmit = async (event) => {
    updateOrder(event);
  };

  const handleSiretChange = (event) => { setMarketmembershipsiret(event.target.value); };
  const handleOrdertypeChange = (event) => { setOrdertype(event.target.value); };
  const handleReferentnameChange = (event) => { setReferentname(event.target.value); };
  const handleNumeroaffaireChange = (event) => { setNumeroaffaire(event.target.value); };
  const handleReferentemailChange = (event) => { setReferentemail(event.target.value); };
  const handleReferentphoneChange = (event) => { setReferentphone(event.target.value); };
  const handlePdlChange = (event) => { setPdl(event.target.value); };
  const handlePdlAutoChange = (newValue) => {
    setMeter(newValue);
    setPdl(newValue.id);
    if (newValue.address) {
      setPdladdress(newValue.address);
    }
    if (newValue.validatedAddress) {
      setPdlvalidatedAddress(newValue.validatedAddress);
    }
  };
  const handlePdladdressChange = (event) => { setPdladdress(event.target.value); };
  const handlePdlinseecodeChange = (event) => { setPdlinseecode(event.target.value); };
  const handlePdlreferenceconsumptionChange = (event) => { setPdlreferenceconsumption(event.target.value); };
  const handlePdlnameChange = (event) => { setPdlname(event.target.value); };
  const handlePdloldnameChange = (event) => { setPdloldname(event.target.value); };
  const handlePdlusagecodeChange = (event) => { setPdlusagecode(event.target.value); };
  const handlePdloldusagecodeChange = (event) => { setPdloldusagecode(event.target.value); };
  const handlePdlcontractualdataChange = (event) => {
    const { name, value } = event.target;
    setPdlcontractualdata((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handlePdloldcontractualdataChange = (event) => {
    const { name, value } = event.target;
    setPdloldcontractualdata((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handlePdldropmeterChange = (event) => { setPdldropmeter(!pdldropmeter); };
  const handleCommentsChange = (event) => { setComments(event.target.value); };
  const handleStartdateChange = (event) => { setStartdate(event.target.value); };
  const handleEnddateChange = (event) => { setEnddate(event.target.value); };
  const handleRenewablemixChange = (event) => { setRenewablemix(event.target.value); };
  const handleBillregroupnameChange = (event) => { setBillregroupname(event.target.value); };
  const handleBillregroupcodeChange = (event) => { setBillregroupcode(event.target.value); };
  const handleBillbudgetcodeChange = (event) => { setBillbudgetcode(event.target.value); };



  const updateOrder = async (event) => {
    await axios
      .put(
        putMarketMembershipOrder(serviceorder.id),
        {
          serviceorderparameters:
          {
            ...serviceorder.parameters,
            ordertype,
            marketmembershipname,
            marketmembershipaddress,
            marketmembershipsiret,
            numeroaffaire,
            referentname,
            referentemail,
            referentphone,
            pdl,
            pdladdress,
            pdloldaddress,
            pdlinseecode,
            pdlreferenceconsumption,
            pdlname,
            pdloldname,
            pdlusagecode,
            pdloldusagecode,
            pdlcontractualdata,
            pdloldcontractualdata,
            comments,
            startdate,
            enddate,
            renewablemix,
            billregroupname,
            billregroupcode,
            billbudgetcode,
            pdldropmeter,
            creationdate: (status === 'validated' || status === 'executed') ? creationdate : (moment().unix()) * 1000,
            status,
          }
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Ordre de service modifié");
        } else setNotification("error", "Une erreur est survenue");
        closeModal();
        refetch();
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const classes = useStyles();

  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <CustomSelect
                inputTitle={memberorder.ordertype}
                selectValue={ordertype}
                handleSelectValueChange={handleOrdertypeChange}
                data={memberorderTypeData}
                disabled
              />
            </div>
            <div>
              <DateInput
                inputTitle={memberorder.executiondate}
                dateInput={startdate}
                handleDateInputChange={handleStartdateChange}
                disabled={(status === 'validated' || status === 'executed')}
              />
            </div>
            {(ordertype === 'provis') &&
              <div>
                <DateInput
                  inputTitle={memberorder.enddate}
                  dateInput={enddate}
                  handleDateInputChange={handleEnddateChange}
                  disabled={(status === 'validated' || status === 'executed')}
                />
              </div>
            }
            <div>
              <TextInput
                isRequired
                inputTitle={memberorder.marketmembershipnumber}
                textInput={marketmembershipnumber}
                disabled
              />
            </div>
            <div>
              <TextInput
                isRequired
                inputTitle={memberorder.marketmembershipname}
                textInput={marketmembershipname}
                disabled
              />
            </div>
            <div>
              <LocalizationAutocomplete
                displayLatLng={false}
                inputTitle={memberorder.marketmembershipaddress}
                value={marketmembershipaddress}
                setValue={setMarketmembershipaddress}
                inputValue={localizationValue}
                setInputValue={setLocalizationValue}
                options={options}
                setOptions={setOptions}
                setValidatedAddress={setValidatedAddress}
                validatedAddress={validatedAddress}
                loaded={loaded}
                specialWidth={"98%"}
                disabled={(status === 'validated' || status === 'executed')}
              />
            </div>
            <div>
              <TextInput
                isRequired
                inputTitle={memberorder.marketmembershipsiret}
                textInput={marketmembershipsiret}
                handleTextInputChange={handleSiretChange}
                disabled={(status === 'validated' || status === 'executed')}
              />
            </div>
            {(status === 'validated' || status === 'executed') &&
              <div>
                <TextInput
                  isRequired
                  inputTitle={memberorder.numeroaffaire}
                  textInput={numeroaffaire}
                  handleTextInputChange={handleNumeroaffaireChange}
                />
              </div>
            }

            <Subsectiontitle>Référent technique</Subsectiontitle>
            <div>
              <TextInput
                isRequired
                inputTitle={memberorder.referentname}
                textInput={referentname}
                handleTextInputChange={handleReferentnameChange}
                disabled={(status === 'validated' || status === 'executed')}
              />
            </div>
            <div>
              <TextInput
                isRequired
                inputTitle={memberorder.referentemail}
                textInput={referentemail}
                handleTextInputChange={handleReferentemailChange}
                disabled={(status === 'validated' || status === 'executed')}
              />
            </div>
            <div>
              <TextInput
                isRequired
                inputTitle={memberorder.referentphone}
                textInput={referentphone}
                handleTextInputChange={handleReferentphoneChange}
                disabled={(status === 'validated' || status === 'executed')}
              />
            </div>
            {(ordertype === 'detach' || ordertype === 'change') ?
              <>
                <Subsectiontitle>Informations du Point de livraison à modifier</Subsectiontitle>
                <div>
                  <TextInput
                    isRequired
                    inputTitle={memberorder.pdl}
                    textInput={pdl}
                    disabled
                  />
                </div>
                <div>
                  <TextInput
                    inputTitle={memberorder.pdlname}
                    textInput={pdloldname}
                    handleTextInputChange={handlePdloldnameChange}
                    disabled={(status === 'validated' || status === 'executed')}
                  />
                </div>
                <div>
                  <LocalizationAutocomplete
                    displayLatLng={false}
                    inputTitle={memberorder.pdladdress}
                    value={pdloldaddress}
                    setValue={setPdloldaddress}
                    inputValue={localizationValue}
                    setInputValue={setLocalizationValue}
                    options={options}
                    setOptions={setOptions}
                    setValidatedAddress={setPdloldvalidatedAddress}
                    validatedAddress={pdloldvalidatedAddress}
                    loaded={loaded}
                    specialWidth={"97%"}
                    disabled={(status === 'validated' || status === 'executed')}
                    freeSolo={true}
                  />
                </div>
                <div>
                  <TextInput
                    inputTitle={memberorder.pdlusagecode}
                    textInput={pdloldusagecode}
                    handleTextInputChange={handlePdloldusagecodeChange}
                    disabled={(status === 'validated' || status === 'executed')}
                  />
                </div>
                <div>
                  <TextInput
                    inputTitle={memberorder.pdlinseecode}
                    textInput={pdlinseecode}
                    handleTextInputChange={handlePdlinseecodeChange}
                    disabled={(status === 'validated' || status === 'executed')}
                  />
                </div>
              </> : <></>
            }
            {(ordertype === 'detach') ?
              <>
                {/* <div> redondant avec date de réalisation (start date)
                  <DateInput
                    inputTitle={memberorder.enddate}
                    dateInput={enddate}
                    handleDateInputChange={handleEnddateChange}
                    disabled={(status === 'validated' || status === 'executed')}
                  />
                </div> */}
                <div>
                  <CustomSwitch
                    inputTitle={memberorder.pdldropmeter}
                    checkedState={pdldropmeter}
                    handleSwitchChange={handlePdldropmeterChange}
                    disabled={(status === 'validated' || status === 'executed')}
                  />
                </div>
              </>
              :
              <>



                {(ordertype === 'change') &&
                  <>
                    <Subsectiontitle>Données contractuelles actuelles</Subsectiontitle>
                    {(market?.parameters?.general?.energy === 'electricity') &&
                      <>
                        <div>
                          <CustomSelect
                            inputTitle={memberorder.electricity.pdltype}
                            selectValue={pdloldcontractualdata?.pdltype}
                            handleSelectValueChange={handlePdloldcontractualdataChange}
                            data={memberorderElectricitySegment}
                            name={"pdltype"}
                            disabled={(status === 'validated' || status === 'executed')}
                          />
                        </div>
                        <div>
                          <CustomSelect
                            inputTitle={memberorder.electricity.turpe}
                            selectValue={pdloldcontractualdata?.turpe}
                            handleSelectValueChange={handlePdloldcontractualdataChange}
                            data={pdloldcontractualdata?.pdltype === 'C5ecl' ? memberorderElectricityTurpeVersionC5Ecl :
                              pdloldcontractualdata?.pdltype === 'C5bat' ? memberorderElectricityTurpeVersionC5 :
                                pdloldcontractualdata?.pdltype ? memberorderElectricityTurpeVersionC4C3C2 : []}
                            name={"turpe"}
                            disabled={(status === 'validated' || status === 'executed')}
                          />
                        </div>

                        {((pdloldcontractualdata?.turpe === 'cu' && pdloldcontractualdata?.pdltype === 'C5bat') ||
                          (pdloldcontractualdata?.pdltype === 'C5ecl')) &&
                          <div>
                            <IntInput
                              inputTitle={memberorder.electricity.psousbase}
                              intInput={pdloldcontractualdata?.psousbase}
                              handleIntInputChange={handlePdloldcontractualdataChange}
                              name={"psousbase"}
                              disabled={(status === 'validated' || status === 'executed')}
                            />
                          </div>
                        }
                        {((pdloldcontractualdata?.turpe === 'mu' && pdloldcontractualdata?.pdltype === 'C5bat')) &&
                          <>
                            <div>
                              <IntInput
                                inputTitle={memberorder.electricity.psoushp}
                                intInput={pdloldcontractualdata?.psoushp}
                                handleIntInputChange={handlePdloldcontractualdataChange}
                                name={"psoushp"}
                                disabled={(status === 'validated' || status === 'executed')}
                              />
                            </div>
                            <div>
                              <IntInput
                                inputTitle={memberorder.electricity.psoushc}
                                intInput={pdloldcontractualdata?.psoushc}
                                handleIntInputChange={handlePdloldcontractualdataChange}
                                name={"psoushc"}
                                disabled={(status === 'validated' || status === 'executed')}
                              />
                            </div>
                          </>
                        }
                        {((pdloldcontractualdata?.turpe === 'lu' && pdloldcontractualdata?.pdltype === 'C5bat') ||
                          (pdloldcontractualdata?.pdltype === 'C4') || (pdloldcontractualdata?.pdltype === 'C3') || (pdloldcontractualdata?.pdltype === 'C2')) &&
                          <>
                            <div>
                              <IntInput
                                inputTitle={memberorder.electricity.psoushph}
                                intInput={pdloldcontractualdata?.psoushph}
                                handleIntInputChange={handlePdloldcontractualdataChange}
                                name={"psoushph"}
                                disabled={(status === 'validated' || status === 'executed')}
                              />
                            </div>
                            <div>
                              <IntInput
                                inputTitle={memberorder.electricity.psoushch}
                                intInput={pdloldcontractualdata?.psoushch}
                                handleIntInputChange={handlePdloldcontractualdataChange}
                                name={"psoushch"}
                                disabled={(status === 'validated' || status === 'executed')}
                              />
                            </div>
                            <div>
                              <IntInput
                                inputTitle={memberorder.electricity.psoushpe}
                                intInput={pdloldcontractualdata?.psoushpe}
                                handleIntInputChange={handlePdloldcontractualdataChange}
                                name={"psoushpe"}
                                disabled={(status === 'validated' || status === 'executed')}
                              />
                            </div>
                            <div>
                              <IntInput
                                inputTitle={memberorder.electricity.psoushce}
                                intInput={pdloldcontractualdata?.psoushce}
                                handleIntInputChange={handlePdloldcontractualdataChange}
                                name={"psoushce"}
                                disabled={(status === 'validated' || status === 'executed')}
                              />
                            </div>
                          </>
                        }
                        {((pdloldcontractualdata?.pdltype === 'C3') || (pdloldcontractualdata?.pdltype === 'C2')) &&
                          <>
                            <div>
                              <IntInput
                                inputTitle={memberorder.electricity.psouspointe}
                                intInput={pdloldcontractualdata?.psouspointe}
                                handleIntInputChange={handlePdloldcontractualdataChange}
                                name={"psouspointe"}
                                disabled={(status === 'validated' || status === 'executed')}
                              />
                            </div>
                          </>
                        }
                        {((pdloldcontractualdata?.pdltype === 'C5ecl')) &&
                          <>
                            <div>
                              <CustomSelect
                                inputTitle={memberorder.electricity.nbhour}
                                selectValue={pdloldcontractualdata?.nbhour}
                                handleSelectValueChange={handlePdloldcontractualdataChange}
                                data={memberorderElectricityEclHourCount}
                                name={"nbhour"}
                                disabled={(status === 'validated' || status === 'executed')}
                              />
                            </div>
                          </>
                        }
                      </>
                    }
                    {(market?.parameters?.general?.energy === 'gas') &&
                      <>
                        <div>
                          <CustomSelect
                            inputTitle={memberorder.gas.profil}
                            selectValue={pdloldcontractualdata?.profil}
                            handleSelectValueChange={handlePdloldcontractualdataChange}
                            data={memberorderGasProfil}
                            name={"profil"}
                            disabled={(status === 'validated' || status === 'executed')}
                          />
                        </div>
                        <div>
                          <CustomSelect
                            inputTitle={memberorder.gas.tarif}
                            selectValue={pdloldcontractualdata?.tarif}
                            handleSelectValueChange={handlePdloldcontractualdataChange}
                            data={memberorderGasTariff}
                            name={"tarif"}
                            disabled={(status === 'validated' || status === 'executed')}
                          />
                        </div>
                      </>
                    }
                  </>
                }
                {(ordertype !== 'detach') &&
                  <>
                    <Subsectiontitle>Informations du Point de livraison souhaitées</Subsectiontitle>
                    {(ordertype === 'attachmeter' || (ordertype === 'provis' && (status === 'validated' || status === 'executed'))) &&
                    // {((status === 'validated' || status === 'executed') && (ordertype === 'attachmeter' || ordertype === 'provis')) &&
                      <div>
                        <TextInput
                          inputTitle={memberorder.pdl}
                          textInput={pdl}
                          handleTextInputChange={handlePdlChange}
                        />
                      </div>
                    }
                    <div>
                      <TextInput
                        inputTitle={memberorder.pdlname}
                        textInput={pdlname}
                        handleTextInputChange={handlePdlnameChange}
                        disabled={(status === 'validated' || status === 'executed')}
                      />
                    </div>
                    <div>
                      <LocalizationAutocomplete
                        displayLatLng={false}
                        inputTitle={memberorder.pdladdress}
                        value={pdladdress}
                        setValue={setPdladdress}
                        inputValue={localizationValue}
                        setInputValue={setLocalizationValue}
                        options={options}
                        setOptions={setOptions}
                        setValidatedAddress={setPdlvalidatedAddress}
                        validatedAddress={pdlvalidatedAddress}
                        loaded={loaded}
                        specialWidth={"97%"}
                        disabled={(status === 'validated' || status === 'executed')}
                        freeSolo={true}
                      />
                    </div>
                    {/* <div>
                      <TextInput
                        inputTitle={memberorder.pdlusagecode}
                        textInput={pdlusagecode}
                        handleTextInputChange={handlePdlusagecodeChange}
                        disabled={(status === 'validated' || status === 'executed')}
                      />
                    </div> */}
                    {(ordertype === 'attachmeter' || ordertype === 'provis') &&
                      <>
                        <div>
                          <TextInput
                            inputTitle={memberorder.pdlreferenceconsumption}
                            textInput={pdlreferenceconsumption}
                            handleTextInputChange={handlePdlreferenceconsumptionChange}
                            disabled={(status === 'validated' || status === 'executed')}
                          />
                        </div>
                        {(market?.parameters?.general?.energy === 'electricity') &&
                          <div>
                            <CustomSelect
                              inputTitle={memberorder.renewablemix}
                              selectValue={renewablemix}
                              handleSelectValueChange={handleRenewablemixChange}
                              data={memberorderElectricityRenewableMix}
                              disabled={(status === 'validated' || status === 'executed')}
                            />
                          </div>
                        }
                        <div>
                          <TextInput
                            inputTitle={memberorder.billregroupname}
                            textInput={billregroupname}
                            handleTextInputChange={handleBillregroupnameChange}
                            disabled={(status === 'validated' || status === 'executed')}
                          />
                        </div>
                        <div>
                          <TextInput
                            inputTitle={memberorder.billregroupcode}
                            textInput={billregroupcode}
                            handleTextInputChange={handleBillregroupcodeChange}
                            disabled={(status === 'validated' || status === 'executed')}
                          />
                        </div>
                        <div>
                          <TextInput
                            inputTitle={memberorder.billbudgetcode}
                            textInput={billbudgetcode}
                            handleTextInputChange={handleBillbudgetcodeChange}
                            disabled={(status === 'validated' || status === 'executed')}
                          />
                        </div>
                      </>
                    }
                    <Subsectiontitle>Données contractuelles souhaitées</Subsectiontitle>
                    {(market?.parameters?.general?.energy === 'electricity') &&
                      <>
                        <div>
                          <CustomSelect
                            inputTitle={memberorder.electricity.pdltype}
                            selectValue={pdlcontractualdata?.pdltype}
                            handleSelectValueChange={handlePdlcontractualdataChange}
                            data={memberorderElectricitySegment}
                            name={"pdltype"}
                            disabled={(status === 'validated' || status === 'executed')}
                          />
                        </div>
                        <div>
                          <CustomSelect
                            inputTitle={memberorder.electricity.turpe}
                            selectValue={pdlcontractualdata?.turpe}
                            handleSelectValueChange={handlePdlcontractualdataChange}
                            data={pdlcontractualdata?.pdltype === 'C5ecl' ? memberorderElectricityTurpeVersionC5Ecl :
                              pdlcontractualdata?.pdltype === 'C5bat' ? memberorderElectricityTurpeVersionC5 :
                                pdlcontractualdata?.pdltype ? memberorderElectricityTurpeVersionC4C3C2 : []}
                            name={"turpe"}
                            disabled={(status === 'validated' || status === 'executed')}
                          />
                        </div>

                        {((pdlcontractualdata?.turpe === 'cu' && pdlcontractualdata?.pdltype === 'C5bat') ||
                          (pdlcontractualdata?.pdltype === 'C5ecl')) &&
                          <div>
                            <IntInput
                              inputTitle={memberorder.electricity.psousbase}
                              intInput={pdlcontractualdata?.psousbase}
                              handleIntInputChange={handlePdlcontractualdataChange}
                              name={"psousbase"}
                              disabled={(status === 'validated' || status === 'executed')}
                            />
                          </div>
                        }
                        {((pdlcontractualdata?.turpe === 'mu' && pdlcontractualdata?.pdltype === 'C5bat')) &&
                          <>
                            <div>
                              <IntInput
                                inputTitle={memberorder.electricity.psoushp}
                                intInput={pdlcontractualdata?.psoushp}
                                handleIntInputChange={handlePdlcontractualdataChange}
                                name={"psoushp"}
                                disabled={(status === 'validated' || status === 'executed')}
                              />
                            </div>
                            <div>
                              <IntInput
                                inputTitle={memberorder.electricity.psoushc}
                                intInput={pdlcontractualdata?.psoushc}
                                handleIntInputChange={handlePdlcontractualdataChange}
                                name={"psoushc"}
                                disabled={(status === 'validated' || status === 'executed')}
                              />
                            </div>
                          </>
                        }
                        {((pdlcontractualdata?.turpe === 'lu' && pdlcontractualdata?.pdltype === 'C5bat') ||
                          (pdlcontractualdata?.pdltype === 'C4') || (pdlcontractualdata?.pdltype === 'C3') || (pdlcontractualdata?.pdltype === 'C2')) &&
                          <>
                            <div>
                              <IntInput
                                inputTitle={memberorder.electricity.psoushph}
                                intInput={pdlcontractualdata?.psoushph}
                                handleIntInputChange={handlePdlcontractualdataChange}
                                name={"psoushph"}
                                disabled={(status === 'validated' || status === 'executed')}
                              />
                            </div>
                            <div>
                              <IntInput
                                inputTitle={memberorder.electricity.psoushch}
                                intInput={pdlcontractualdata?.psoushch}
                                handleIntInputChange={handlePdlcontractualdataChange}
                                name={"psoushch"}
                                disabled={(status === 'validated' || status === 'executed')}
                              />
                            </div>
                            <div>
                              <IntInput
                                inputTitle={memberorder.electricity.psoushpe}
                                intInput={pdlcontractualdata?.psoushpe}
                                handleIntInputChange={handlePdlcontractualdataChange}
                                name={"psoushpe"}
                                disabled={(status === 'validated' || status === 'executed')}
                              />
                            </div>
                            <div>
                              <IntInput
                                inputTitle={memberorder.electricity.psoushce}
                                intInput={pdlcontractualdata?.psoushce}
                                handleIntInputChange={handlePdlcontractualdataChange}
                                name={"psoushce"}
                                disabled={(status === 'validated' || status === 'executed')}
                              />
                            </div>
                          </>
                        }
                        {((pdlcontractualdata?.pdltype === 'C3') || (pdlcontractualdata?.pdltype === 'C2')) &&
                          <>
                            <div>
                              <IntInput
                                inputTitle={memberorder.electricity.psouspointe}
                                intInput={pdlcontractualdata?.psouspointe}
                                handleIntInputChange={handlePdlcontractualdataChange}
                                name={"psouspointe"}
                                disabled={(status === 'validated' || status === 'executed')}
                              />
                            </div>
                          </>
                        }
                        {((pdlcontractualdata?.pdltype === 'C5ecl')) &&
                          <>
                            <div>
                              <CustomSelect
                                inputTitle={memberorder.electricity.nbhour}
                                selectValue={pdlcontractualdata?.nbhour}
                                handleSelectValueChange={handlePdlcontractualdataChange}
                                data={memberorderElectricityEclHourCount}
                                name={"nbhour"}
                                disabled={(status === 'validated' || status === 'executed')}
                              />
                            </div>
                          </>
                        }
                      </>
                    }
                    {(market?.parameters?.general?.energy === 'gas') &&
                      <>
                        <div>
                          <CustomSelect
                            inputTitle={memberorder.gas.profil}
                            selectValue={pdlcontractualdata?.profil}
                            handleSelectValueChange={handlePdlcontractualdataChange}
                            data={memberorderGasProfil}
                            name={"profil"}
                            disabled={(status === 'validated' || status === 'executed')}
                          />
                        </div>
                        <div>
                          <CustomSelect
                            inputTitle={memberorder.gas.tarif}
                            selectValue={pdlcontractualdata?.tarif}
                            handleSelectValueChange={handlePdlcontractualdataChange}
                            data={memberorderGasTariff}
                            name={"tarif"}
                            disabled={(status === 'validated' || status === 'executed')}
                          />
                        </div>
                      </>
                    }

                  </>
                }
              </>
            }
            <Subsectiontitle>Autres précisions</Subsectiontitle>
            <div>
              <TextInput
                inputTitle={memberorder.comments}
                textInput={comments}
                handleTextInputChange={handleCommentsChange}
                disabled={(status === 'validated' || status === 'executed')}
              />
            </div>


            <Button
              disabled={buttonDisabled}
              className={
                buttonDisabled
                  ? classes.submitButtonDisabled
                  : classes.submitButton
              }
              onClick={() => {
                handleSubmit();
              }}
            >
              Modifier
            </Button>
          </GridItem>
        </GridContainer>
      </form>
    </>
  );
}
export default EditServiceOrderDialog;
